export default function FacebookLoginButton(props) {
  let { redirectTo = "" } = props;
  if (!redirectTo) {
    const { pathname } = window.location;
    if (pathname.includes('log-in') || pathname.includes('sign-up')) redirectTo = "/";
    else redirectTo = pathname;
  }

  const href = `${process.env.REACT_APP_BACK_END_DOMAIN}/api/session/login/facebook?redirectTo=${redirectTo}`;

  return (
    <a
      className='btn btn-primary facebook-icon'
      href={href}
      style={{ margin: 5, padding: 2, width: 220 }}
    >
      <i className="fab fa-facebook-f" />
      {" "}
      Sign In with Facebook
    </a>
  );
}